import React from 'react';
import markdownit from 'markdown-it'

interface Props {
  text: string;
}

export default (props: Props) => {
  if (!props.text) return;

  const md = markdownit({ html: true });
  const processedMarkdown = md.render(props.text).replace(/<\/strong>\n/g, '</strong><br />');

  if (processedMarkdown.indexOf('<p>') !== -1){
    return (
      <div dangerouslySetInnerHTML={{ __html: processedMarkdown }} />
    );
  }

  return (
    <>
      {
        props.text.replace(/\r\n/g, '\n').split(/\n+/).map((paragraph, idx) => (
          <p key={idx}>{paragraph}</p>
        ))
      }
    </>
  );
};
